module.exports = __webpack_public_path__ + "img/section-divider.6a4e22a5.svg";